import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';

function TabPanel(props) {
    const { children, index, selectedTab, style, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={selectedTab !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {selectedTab === index && (
                <Box style={style || {}} p={3}>
                    {children}
                </Box>
            )}
        </Typography>
    );
}

export { TabPanel };
